import React from 'react';
import { Link } from 'react-router-dom';

import destinationBg from '../../assets/img/bg/destination.png';
import desIcon1 from '../../assets/img/icons/destination-icon-1.png';
import desIcon2 from '../../assets/img/icons/destination-icon-2.png';
import destination1 from '../../assets/img/destination/destination-1-1.png';
import tokyoImg from '../../assets/img/tokyo.webp';

import sriLankaImg from '../../assets/img/srilanka.jpg';
import turkeyImg from '../../assets/img/turkey.jpg';
import saudiArabiaImg from '../../assets/img/saudi-arabia.jpg';
import keralaImg from '../../assets/img/kerala.jpg';
import westBengalImg from '../../assets/img/west-bengal.jpg';
import karnatakaImg from '../../assets/img/kRNtK.png';

const Destinations = () => {
    const destinations = [
        {
            id: 1,
            image: sriLankaImg,
            title: "Sri Lanka",
            discount: "25% discount",
            packageId: "sri-lanka",
            active: true
        },
        {
            id: 2,
            image: turkeyImg,
            title: "Turkey",
            discount: "30% discount",
            packageId: "turkey",
            active: false
        },
        {
            id: 3,
            image: saudiArabiaImg,
            title: "Saudi Arabia",
            discount: "20% discount",
            packageId: "saudi-arabia",
            active: false
        },
        {
            id: 4,
            image: keralaImg,
            title: "Kerala",
            discount: "35% discount",
            packageId: "kerala-retreat",
            active: false
        },
        {
            id: 5,
            image: westBengalImg,
            title: "West Bengal",
            discount: "15% discount",
            packageId: "west-bengal",
            active: false
        },
        {
            id: 6,
            image: karnatakaImg,
            title: "Karnataka",
            discount: "25% discount",
            packageId: "karnataka-heritage",
            active: false
        },
        {
            id: 7,
            image: destination1,
            title: "thailand trip",
            discount: "30% discount",
            packageId: "thailand",
            active: false
        },
        {
            id: 8,
            image: tokyoImg,
            title: "tokyo",
            discount: "30% discount",
            packageId: "tokyo",
            active: false
        }
    ];

    return (
        <section
            className="vs-destination-style1 bg-third-theme-12 overflow-hidden space"
            style={{ backgroundImage: `url(${destinationBg})` }}
        >
            <img
                className="des-icon-1 animate-parachute"
                src={desIcon1}
                alt="icon"
            />
            <img
                className="des-icon-2 animate-tree"
                src={desIcon2}
                alt="icon"
            />
            <div className="container">
                <div className="row">
                    <div className="col-lg-auto mx-auto">
                        <div className="title-area text-center">
                            <span className="sec-subtitle fade-anim" data-direction="top">
                                Top Destinations
                            </span>
                            <h2 className="sec-title move-anim">Discover Top Destinations</h2>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div className="destination-slider-wrapper">
                            <div className="destination-scroll-container">
                                {destinations.map((destination) => (
                                    <div
                                        key={destination.id}
                                        className="destination-slide"
                                    >
                                        <div className={`destination-box ${destination.active ? 'active' : ''}`}>
                                            <div className="destination-thumb">
                                                <img
                                                    src={destination.image}
                                                    alt={destination.title}
                                                    className="w-100"
                                                />
                                            </div>
                                            <div className="destination-content">
                                                <div className="info">
                                                    <h4 className="text-white text-capitalize">
                                                        <Link to={destination.packageId ? `/book/${destination.packageId}` : "/destinationdetails"}>
                                                            {destination.title}
                                                        </Link>
                                                    </h4>
                                                    <span className="text-theme-color d-block">{destination.discount}</span>
                                                </div>
                                                <Link 
                                                    to={destination.packageId ? `/book/${destination.packageId}` : "/destinationdetails"} 
                                                    className="icon bg-theme-color text-white-color"
                                                >
                                                    <i className="fa-solid fa-location-dot"></i>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="text-center mt-50 btn-trigger btn-bounce">
                            <Link to="/destinationdetails" className="vs-btn style4">
                                <span>view more</span>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>

            <style jsx>{`
                .destination-slider-wrapper {
                    width: 100%;
                    overflow-x: auto;
                    padding: 20px 0;
                    -webkit-overflow-scrolling: touch;
                    scrollbar-width: thin;
                    scrollbar-color: #ccc transparent;
                }

                .destination-slider-wrapper::-webkit-scrollbar {
                    height: 6px;
                }

                .destination-slider-wrapper::-webkit-scrollbar-track {
                    background: transparent;
                }

                .destination-slider-wrapper::-webkit-scrollbar-thumb {
                    background-color: #ccc;
                    border-radius: 10px;
                }

                .destination-scroll-container {
                    display: flex;
                    gap: 20px;
                    min-width: min-content;
                    padding: 0 10px;
                }

                .destination-slide {
                    flex: 0 0 300px;
                    min-width: 300px;
                }

                @media (max-width: 768px) {
                    .destination-slide {
                        flex: 0 0 280px;
                        min-width: 280px;
                    }
                }

                @media (max-width: 576px) {
                    .destination-slide {
                        flex: 0 0 260px;
                        min-width: 260px;
                    }
                }
            `}</style>
        </section>
    );
};

export default Destinations;